export default {
  testimonialsListState(state) {
    return state.list;
  },
};
